import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7275ab07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "See More", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `${_ctx.route}`,
    onClick: _withModifiers(_ctx.handleDisplay, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["card card-body shadow-sm border-0", [_ctx.card.customCard]])
        }, [
          (_ctx.body.title)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: _normalizeClass(["mb-1 fw-bold", [_ctx.card.customTitle]]),
                "data-testid": "title"
              }, _toDisplayString(_ctx.body.title), 3))
            : _createCommentVNode("", true),
          (_ctx.body.requirements)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass([_ctx.card.customBody]),
                "data-testid": "title"
              }, [
                _createTextVNode(_toDisplayString(_ctx.trimText(_ctx.body.requirements, 200)) + " ", 1),
                _hoisted_2
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.body.innovator)
            ? (_openBlock(), _createElementBlock("p", {
                key: 2,
                class: _normalizeClass([[_ctx.card.customInnovator], "card-text mt-2"])
              }, [
                _createElementVNode("strong", null, "Innovator: " + _toDisplayString(_ctx.body.innovator), 1)
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["to", "onClick"]))
}